import types from '../mutation-types';
import ConversationFinishedReportsAPI from '../../api/conversationFinishedReports';
import { downloadCsvFile } from 'dashboard/helper/downloadHelper';

export const state = {
  summary: [],
  detailed: [],
  uiFlags: {
    isFetching: false,
    isFetchingDetailed: false,
  },
};

export const getters = {
  getSummary(_state) {
    return _state.summary;
  },
  getDetailed(_state) {
    return _state.detailed;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  getSummary: async function getSummary({ commit }, params) {
    commit(types.SET_CONVERSATION_FINISHED_REPORTS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ConversationFinishedReportsAPI.getSummary(params);
      commit(types.SET_CONVERSATION_FINISHED_REPORTS_SUMMARY, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FINISHED_REPORTS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  getDetailed: async function getDetailed({ commit }, params) {
    commit(types.SET_CONVERSATION_FINISHED_REPORTS_UI_FLAG, {
      isFetchingDetailed: true,
    });
    try {
      const response = await ConversationFinishedReportsAPI.getDetailed(params);
      commit(types.SET_CONVERSATION_FINISHED_REPORTS_DETAILED, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FINISHED_REPORTS_UI_FLAG, {
        isFetchingDetailed: false,
      });
    }
  },
  downloadSummaryReport(_, params) {
    return ConversationFinishedReportsAPI.downloadSummaryReport(params).then(
      response => {
        downloadCsvFile(params.fileName, response.data);
      }
    );
  },
  downloadDetailedReport(_, params) {
    return ConversationFinishedReportsAPI.downloadDetailedReport(params).then(
      response => {
        downloadCsvFile(params.fileName, response.data);
      }
    );
  },
};

export const mutations = {
  [types.SET_CONVERSATION_FINISHED_REPORTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONVERSATION_FINISHED_REPORTS_SUMMARY](_state, data) {
    _state.summary = data;
  },
  [types.SET_CONVERSATION_FINISHED_REPORTS_DETAILED](_state, data) {
    _state.detailed = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
